<template>
    <el-main>
        <div class="breadcrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>Launcher Management</el-breadcrumb-item>
                <el-breadcrumb-item>Activation Policies</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-row style="margin-top: 24px">
            <el-col :span="16">
                <div class="main-title">
                    Policy List
                </div>

            </el-col>
            <el-col :span="8" class="text-right">

            </el-col>
        </el-row>

        <el-row type="flex" style="margin-top:24px">
            <el-col :span="24">
                <el-card class="box-card">
                    <el-row style="margin-bottom: 18px" :gutter="15">
                        <el-col :span="4" :offset="20">
                            <el-input v-model="query.search" size="small" placeholder="Name" class="filter-item" @keyup.enter.native="search"/>
                        </el-col>
                    </el-row>
                    <el-table
                            :data="policies"
                            stripe
                            style="width: 100%">
                        <el-table-column
                                prop="country.name"
                                label="GSR Country">
                        </el-table-column>
                        <el-table-column
                                width="80"
                                prop="step2"
                                label="Step 2">
                            <template slot-scope="scope">
                                <i :class="{'text-xl el-icon-check text-green' : scope.row.activeRecord.step2Mandatory, 'text-xl el-icon-close text-red' : !scope.row.activeRecord.step2Mandatory}"></i>
                            </template>
                        </el-table-column>
                        <el-table-column
                                width="80"
                                prop="step3"
                                label="Step 3">
                            <template slot-scope="scope">
                                <i :class="{'text-xl el-icon-check text-green' : scope.row.activeRecord.step3Mandatory, 'text-xl el-icon-close text-red' : !scope.row.activeRecord.step3Mandatory}"></i>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="Future Policy">
                            <template slot-scope="scope">
                                <span v-if="scope.row.futurePolicy">{{scope.row.futurePolicyDate | formatDate}}</span>
                                <span v-else>N/A</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="activeRecord.remarks"
                                label="Remarks">
                        </el-table-column>

                        <el-table-column label="Actions">
                            <template slot-scope="scope">
                                <el-button size="mini" icon="el-icon-edit" @click="manage(scope.row.id)"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <pagination v-show="query.total>0" :total="query.total" :page.sync="query.page" :limit.sync="query.limit" @pagination="searchData" />
                </el-card>
            </el-col>
        </el-row>

    </el-main>
</template>

<script>
import api from "@/services/api/WRCService"
import Pagination from "@/components/Pagination"

export default {
    components: { Pagination },
    data: function() {
        return {
            policies: [],
            loading: false,
            query: {
                total: 0,
                page: 0,
                limit: 10,
                pageSize: 0,
                search: ''
            }
        }
    },
    methods:{
        manage : function(policyId) {
            this.$router.push({ name: 'ManageActivationPolicy', params: { policyId } })
        },
        search() {
            this.query.page = 1;
            this.searchData();
        },
        searchData() {
            this.loading = true;

            api.getPolicies(this.query.search, {
                page: this.query.page - 1,
                size: this.query.limit
            }).then(({ data }) => {

                this.policies.splice(0, this.policies.length);
                this.policies.push(...data.data.items);
                this.query.total = data.data.pagination.totalRecords;
            }).catch(() => {}).then(() => {
                this.loading = false;
            });
        }
    },
    mounted() {
        //this.pagination.pageSize = Number(LocalStorageUtil.get('user', 'pageSize'));
        this.searchData();
    }
}
</script>
